import React, { Component } from 'react'
import { 
  DistrictsCard, AddDistrictsModal, SchoolsCard, 
  AddSchoolsModal, StudentsCard, AddStudentsModal,
  RegistrationCodeModal, ImportUsersModal, ManageRecordModal,
} from '.'

/* ManageStudentContainer

  <ManageStudents
    isInitializing={this.props.isInitializing}
    isInitializingError={this.props.isInitializingError}
    districts={this.props.districts}
    schools={this.props.schools}
    educators={this.props.educators}
    classes={this.props.classes}
    students={this.props.students}
    user={this.user}
    selection={selection}
    modal={modal}
    openModal={this.openModal}
    closeModal={this.closeModal}
    select={this.select}
    forceDistrictExpanded={this.state.forceDistrictExpanded}
    filters={this.props.filters}
    districtNameSearch={this.state.districtNameSearch}
    setFilter={this.props.setFilter}
    setSearch={this.setSearch}
    setForceExpanded={this.setForceExpanded}
    forceSchoolExpanded={this.state.forceSchoolExpanded}
  />
*/

class ManageStudents extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let permissionSuper, permissionDistrict, permissionSchool, permissionTeacher
    if (this.props.user) {
      permissionSuper = this.props.user.role === 'Super Administrator'
      permissionDistrict = this.props.user.role === 'District Admin' || permissionSuper
      permissionSchool = this.props.user.role === 'School Admin' || permissionDistrict
      permissionTeacher = this.props.user.role === 'Teacher' || permissionSchool
    }

    let component = <p>Loading...<br /><i className='fa fa-spinner fa-lg fa-spin mt-4'></i></p>

    if (this.props.isInitializing) {
      component = (
        <p>Loading...<br /><i className="fa fa-spinner fa-lg fa-spin mt-4"></i></p>
      )
    } else if (this.props.user && this.props.districts) {
      component = []
      if (permissionDistrict) {
        component.push(
          <DistrictsCard
            districts={this.props.districts}
            selectedDistrict={this.props.selection.district}
            key='DistrictsCard'
            openModal={this.props.openModal}
            select={this.props.select}
            setForceExpanded={this.props.setForceExpanded}
            forceDistrictExpanded={this.props.forceDistrictExpanded}
            districtNameSearch={this.props.districtNameSearch}
            districtStateFilter={this.props.filters.districtState}
            setFilter={this.props.setFilter}
            setSearch={this.props.setSearch}
            permissionSuper={permissionSuper}
          />
        )
      }
      if (permissionSuper) {
        component.push(
          <AddDistrictsModal
            isOpen={this.props.modal === 'addDistrict'}
            toggle={this.props.closeModal}
            key='AddDistrictsModal'
            select={this.props.select}
          />
        )
      }
      if (permissionSchool) {
        component.push(
          <SchoolsCard
            districts={this.props.districts}
            schools={this.props.schools}
            key='SchoolsCard'
            selectedDistrict={this.props.selection.district}
            selectedSchool={this.props.selection.school}
            select={this.props.select}
            openModal={this.props.openModal}
            educators={this.props.educators}
            setForceExpanded={this.props.setForceExpanded}
            forceSchoolExpanded={this.props.forceSchoolExpanded}
            view={'students'}
            permissionDistrict={permissionDistrict}
          />
        )
      }
      component.push(
        <AddSchoolsModal
          isOpen={this.props.modal === 'addSchool'}
          toggle={this.props.closeModal}
          key='AddSchoolsModal'
          select={this.props.select}
          selectedDistrict={this.props.selection.district}
        />
      )
      component.push(
        <StudentsCard
          selectedSchool={this.props.selection.school}
          selectedStudent={this.props.selection.student}
          key='StudentsCard'
          select={this.props.select}
          students={this.props.students}
          schools={this.props.schools}
          openModal={this.props.openModal}
        />
      )
      component.push(
        <AddStudentsModal
          isOpen={this.props.modal === 'addStudent'}
          key='AddStudentsModal'
          toggle={this.props.closeModal}
          select={this.props.select}
          selectedSchool={this.props.selection.school}
          schools={this.props.schools}
        />
      )
      if (this.props.schools && this.props.selection.school) {
        component.push(
          <RegistrationCodeModal
            isOpen={this.props.modal === 'studentRegistrationCode'}
            key='StudentRegistrationCodeModal'
            toggle={this.props.closeModal}
            selectedSchool={this.props.selection.school}
            role='student'  
          />
        )
      }

      if (this.props.schools && this.props.selection.school) {
        component.push(
          <ImportUsersModal
            isOpen={this.props.modal === 'importStudents'}
            key='ImportStudentsModal'
            toggle={this.props.closeModal}
            school={this.props.schools[this.props.selection.school]}
            role='Students'
          />
        )
      } 

      if (this.props.districts && this.props.schools && this.props.students && this.props.districts && this.props.classes) {
        component.push(
          <ManageRecordModal
            isOpen={this.props.modal === 'record'}
            key='ManageRecordModal'
            toggle={this.props.closeModal}
            recordId={this.props.recordId}
            educators={this.props.educators}
            schools={this.props.schools}
            students={this.props.students}
            districts={this.props.districts}
            classes={this.props.classes}
            deleteRecord={this.props.deleteRecord}
            isDeleting={this.props.isDeleting}
            isDeletingError={this.props.isDeletingError}
          />
        )
      }
      
    }

    return (
      <div>{component}</div>
    )
  }
}

export default ManageStudents


// WEBPACK FOOTER //
// ./src/components/Users/ManageStudents.js